import { render, staticRenderFns } from "./tpay.vue?vue&type=template&id=2515e3da&"
import script from "./tpay.vue?vue&type=script&lang=js&"
export * from "./tpay.vue?vue&type=script&lang=js&"
import style0 from "./tpay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports